import React from 'react';
import { Container } from '@fiverr-private/layout_components';
import { IconButton } from '@fiverr-private/button';
import { ChevronLeftIcon, ChevronRightIcon } from '@fiverr-private/visuals';
import { useCarouselContext } from '../../Carousel/constants';
import type { ArrowProps } from './types';
import { getIconSize } from './constants';

const Arrow = ({ arrowDirection, size, onArrowClick, hideWhenDisabled, ...restContainerProps }: ArrowProps) => {
  const { scrollLeft, scrollRight, canScrollLeft, canScrollRight, canScrollOnInfinite, swipeMode } =
    useCarouselContext();
  const isLeft = arrowDirection === 'left';
  const canScroll = canScrollOnInfinite || (isLeft && canScrollLeft) || (!isLeft && canScrollRight);
  const ChevronIcon = isLeft ? ChevronLeftIcon : ChevronRightIcon;
  const isArrowDisabled = swipeMode || !canScroll;
  const handleClick = (e: React.MouseEvent<Element, MouseEvent>) => {
    if (isLeft) {
      scrollLeft?.();
      onArrowClick?.('left', e);
    } else {
      scrollRight?.();
      onArrowClick?.('right', e);
    }
  };

  return (
    <Container
      width="fit-content"
      height="fit-content"
      borderRadius="circle"
      onClick={handleClick}
      hidden={hideWhenDisabled && isArrowDisabled}
      pointerEvents={isArrowDisabled ? 'none' : undefined}
      backgroundColor="white"
      boxShadow={{ default: 'z1', hover: 'z2' }}
      zIndex="2"
      opacity={isArrowDisabled ? '0.5' : undefined}
      {...restContainerProps}
    >
      <IconButton size={size} shape="circle" colorScheme="white" aria-label={arrowDirection}>
        <ChevronIcon color="grey_900" size={getIconSize(size)} />
      </IconButton>
    </Container>
  );
};

Arrow.displayName = 'Arrow';
export default Arrow;
